import { Injectable } from "@angular/core";
import { PublicHttpClientService } from "./http-client.service";

import { Observable } from "rxjs";
import { HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";

@Injectable()
export class PublicOpenBankingService {
  constructor(private http: PublicHttpClientService) {}

  public getCredentialCodes(): Observable<any> {
    return this.http
      .get("/api/public/open_banking/credential_codes")
      .pipe(tap((_) => console.log("OpenBankingService.getErrors: Ok.")));
  }

  public getPreviousBelvoData(vp_id): Observable<boolean> {
    const params = {
      validation_process_id: vp_id,
    };
    return this.http
      .post("/api/public/validation_processes/open_banking/belvo/check_data", params)
      .pipe(tap((_) => console.log("OpenBankingService.getPreviousBelvoData: Ok")));
  }

  public getBanksByOrganizationId(id: string): Observable<any> {
    return this.http
      .get("/api/public/open_banking/banks/" + id)
      .pipe(tap((_) => console.log("OpenBankingService.getBanksByOrganizationId: Ok.")));
  }

  public getActiveBanks(provider): Observable<any> {
    let options = { params: { provider: provider } };
    return this.http
      .get("/api/public/open_banking/banks", options)
      .pipe(tap((_) => console.log("OpenBankingService.getActiveBanks: Ok.")));
  }

  public getOrganizations(): Observable<any> {
    return this.http
      .get("/api/public/validation_processes/open_banking/organizations", {})
      .pipe(tap((_) => console.log("OpenBankingService.getOrganization: Ok.")));
  }

  public getCredentials(id: string): Observable<any> {
    return this.http
      .get("/api/public/validation_processes/" + id + "/open_banking/credentials")
      .pipe(tap((_) => console.log("OpenBankingService.getCredentials: Ok.")));
  }

  public getBankfields(id): Observable<any> {
    return this.http.get("/api/open_banking/bankfields/" + id, {}).pipe(
      tap((_) => console.log("OpenBankingService.getBankfields: Ok.")),
      map((response: HttpResponse<object>) => {
        return response;
      })
    );
  }
}
